import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';

const VoucherGroupsQuery = gql`
    query($eshopDomain: String!) {
        voucherGroups(eshopDomain: $eshopDomain) {
            id
            active
            giftId
            title
            source
            type
            amount
            fixDiscountAmount
            minimumPriceOfSingleItem
            maximumPriceOfSingleItem
            minimumPriceOfOrder
            maximumPriceOfOrder

            minimumPricesOfSingleItem {
                currencyId
                priceWithout
                recommendedPriceWithout
            }
            maximumPricesOfSingleItem {
                currencyId
                priceWithout
                recommendedPriceWithout
            }
            minimumPricesOfOrder {
                currencyId
                priceWithout
                recommendedPriceWithout
            }
            maximumPricesOfOrder {
                currencyId
                priceWithout
                recommendedPriceWithout
            }
            
            applyToDiscountedGoods

            includedProductTags
            excludedProductTags

            includedProducts

            freeShipping {
                id
            }

            vouchers {
                id
            }

            customerGroups {
                id
            }
            customerIds
        }
    }
`;

const CreateVoucherGroupMutation = gql`
    mutation($eshopDomain: String!, $voucherGroup: VoucherGroupInput!) {
        createVoucherGroup(eshopDomain: $eshopDomain, voucherGroup: $voucherGroup) {
            id
        }
    }
`;

const UpdateVoucherGroupMutation = gql`
    mutation($id: String!, $voucherGroup: VoucherGroupInput!) {
        updateVoucherGroup(id: $id, voucherGroup: $voucherGroup) {
            id
        }
    }
`;

const DeleteVoucherGroupMutation = gql`
    mutation($id: String!) {
        deleteVoucherGroup(id: $id) {
            id
        }
    }
`;

interface IInputProps {
    children?: any;
    eshopDomain: string;
}

interface Response {
    data: any;
}

class GetVoucherGroupsQuery extends React.Component<ChildProps<IInputProps, Response>, {}> {
    render() {
        const { voucherGroups, createVoucherGroup, updateVoucherGroup, deleteVoucherGroup }: any = this.props;
        return this.props.children({
            voucherGroups,
            createVoucherGroup,
            updateVoucherGroup,
            deleteVoucherGroup
        });
    }
}

export default compose(
    graphql<IInputProps, Response>(VoucherGroupsQuery, {
        name: 'voucherGroups',
        options: props => ({
            variables: {
                eshopDomain: props.eshopDomain
            }
        })
    }),
    graphql<IInputProps, Response>(CreateVoucherGroupMutation, {
        name: 'createVoucherGroup'
    }),
    graphql<IInputProps, Response>(UpdateVoucherGroupMutation, {
        name: 'updateVoucherGroup'
    }),
    graphql<IInputProps, Response>(DeleteVoucherGroupMutation, {
        name: 'deleteVoucherGroup'
    })
)(GetVoucherGroupsQuery);



// WEBPACK FOOTER //
// ./src/components/Query/VoucherGroups/VoucherGroups.tsx